export const ZENDESK_SCRIPT_URL = 'https://static.zdassets.com/ekr/snippet.js?key=b7d80b15-0373-49c2-8333-a8f424f04bb2';
export const ZENDESK_LOAD_DELAY_MS = 5000;
export const ZENDESK_SNIPPET_ID = 'ze-snippet';
